import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

// ngrx
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { effects } from 'src/app/store';
/*  combined common modules into one file */
import { ScrollingModule } from '@angular/cdk/scrolling';

import { ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { NgxGaugeModule } from 'ngx-gauge';
import { NgxPaginationModule } from 'ngx-pagination';
import { NavigationRecordComponent } from 'src/app/shared/portal-layout/header/navigation-record/navigation-record.component';
import { PaginationComponent } from '../shared/components/pagination/pagination.component';
import { SharedModule } from '../shared/shared.module';

// widget components
import { DownloadChartsPdfDialogComponent } from './components/download-charts-pdf/download-charts-pdf-dialog/download-charts-pdf-dialog.component';
import { DownloadChartsPdfSnackbarComponent } from './components/download-charts-pdf/download-charts-pdf-snackbar/download-charts-pdf-snackbar.component';
import { GaugeValueModalComponent } from './components/gauge-value/gauge-value-modal/gauge-value-modal.component';
import { GaugeValueComponent } from './components/gauge-value/gauge-value.component';
import { HorizontalBarsModalComponent } from './components/horizontal-bars/horizontal-bars-modal/horizontal-bars-modal.component';
import { HorizontalBarsComponent } from './components/horizontal-bars/horizontal-bars.component';
import { LineValuesModalComponent } from './components/line-values/line-values-modal/line-values-modal.component';
import { LineValuesComponent } from './components/line-values/line-values.component';
import { SingleValueModalComponent } from './components/single-value/single-value-modal/single-value-modal.component';
import { SingleValueComponent } from './components/single-value/single-value.component';
import { VerticalBarsModalComponent } from './components/vertical-bars/vertical-bars-modal/vertical-bars-modal.component';
import { VerticalBarsComponent } from './components/vertical-bars/vertical-bars.component';

// components & containers
import * as fromComponents from './components';
import * as fromContainers from './containers';

import * as fromContactsReducer from '../store/reducers/contacts.reducer';
import * as fromLineItemsReducer from '../store/reducers/line-items.reducer';
import * as fromServicesReducer from '../store/reducers/services.reducer';
import * as fromTicketsReducer from '../store/reducers/tickets.reducer';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    MatMenuModule,
    NgxGaugeModule,
    MatTooltipModule,
    OverlayModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatExpansionModule,
    MatFormFieldModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    ScrollingModule,
    MatPaginatorModule,
    MatIconModule,
    StoreModule.forFeature('contacts', fromContactsReducer.reducer),
    StoreModule.forFeature('services', fromServicesReducer.reducer),
    StoreModule.forFeature('tickets', fromTicketsReducer.reducer),
    StoreModule.forFeature('lineItems', fromLineItemsReducer.reducer),
    EffectsModule.forFeature(effects),
    NavigationRecordComponent,
    PaginationComponent,
    GaugeValueComponent,
    GaugeValueModalComponent,
    ...fromComponents.standaloneComponents,
  ],
  declarations: [
    ...fromComponents.components,
    ...fromContainers.containers,
    SingleValueComponent,
    SingleValueModalComponent,
    VerticalBarsComponent,
    VerticalBarsModalComponent,
    HorizontalBarsComponent,
    HorizontalBarsModalComponent,
    LineValuesComponent,
    LineValuesModalComponent,
    DownloadChartsPdfDialogComponent,
    DownloadChartsPdfSnackbarComponent,
  ],
  providers: [DecimalPipe],
  exports: [
    ...fromComponents.standaloneComponents,
    ...fromComponents.components,
    ...fromContainers.containers,
    SingleValueComponent,
    SingleValueModalComponent,
    VerticalBarsComponent,
    VerticalBarsModalComponent,
    HorizontalBarsComponent,
    HorizontalBarsModalComponent,
    LineValuesComponent,
    LineValuesModalComponent,
    GaugeValueComponent,
    GaugeValueModalComponent,
    DownloadChartsPdfDialogComponent,
    DownloadChartsPdfSnackbarComponent,
  ],
})
export class TicketModule {}
